//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, mqMax } from "../../styles/theme";
import CirlceIcon from "../CircleIcon";
import { TimerStack } from "../ImageStack";
import panda1 from "./panda1.png";
import panda2 from "./panda2.png";
import panda3 from "./panda3.png";

const Cell = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${theme.space3};
  padding-bottom: ${theme.space3};
  font-weight: ${theme.display.fontWeight};
  flex-direction: column;
  align-items: center;
  ${mqMin(theme.tablet)} {
    justify-content: space-around;
    flex-direction: row;
    padding-bottom: ${theme.space4};
  }
`;

const Heading = styled.div`
  ${mqMax(theme.tablet)} {
    margin-bottom: ${theme.space3};
  }
  ${mqMin(theme.tablet)} {
    order: ${props => (props.index % 2 ? 0 : 99)};
  }
`;

const TextWrapper = styled.div`
  padding-left: ${theme.space2};
  padding-right: ${theme.space2};
  ${mqMin(theme.tablet)} {
    width: 63.3%;
  }
`;
const Text = styled.div`
  font-size: ${theme.h4};
  font-family: ${theme.display.fontFamily};
  font-weight: ${theme.display.fontWeight};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h3};
  }
`;

export default ({ heading, text, index, images }) => (
  <Cell>
    <Heading index={index}>
      <CirlceIcon text={heading}>
        <TimerStack images={images} />
      </CirlceIcon>
    </Heading>
    <TextWrapper>
      <Text dangerouslySetInnerHTML={{ __html: text }} />
    </TextWrapper>
  </Cell>
);



// WEBPACK FOOTER //
// ./src/components/ProcessItem/index.js